import React from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useSelector } from 'react-redux';
import Badge from '../../Notice/ui/Badge';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';

export default function UserDetailCard() {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const {
    tbmProgress,
    waitingPaymentInfoWaitCnt,
    tbmManagerYn,
    waitingPaymentInfoLastTitle,
  } = useSelector((state) => state.homeInfo);
  const { navigate } = useAppNavigate();

  return (
    <section className="flex gap-2.5">
      <div
        className="bg-card-light flex flex-1 items-center gap-3 rounded-xl p-4 shadow-sm"
        onClick={() =>
          tbmManagerYn &&
          userInfo?.internalYn !== '1' &&
          navigate('/M_TBMCompletionStatus')
        }
      >
        <div className="relative flex h-12 w-12 shrink-0 items-center justify-center">
          <CircularProgressbar
            value={Math.min(100, (tbmProgress / 7200) * 100)}
            strokeWidth={10}
            styles={buildStyles({
              pathColor: '#5ABD4F',
              trailColor: '#F1F5F9',
              strokeLinecap: 'round',
            })}
          />
          <span className="absolute text-[11px] font-bold">
            {Math.round(Math.min(100, (tbmProgress / 7200) * 100))}%
          </span>
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-sm font-bold">TBM 이수</p>
          <p className="text-2xs leading-tight text-slate-500">
            목표 달성까지 <br /> 힘내세요!
          </p>
        </div>
      </div>
      <div
        className="relative flex flex-1 flex-col justify-center overflow-hidden rounded-xl border border-orange-100 bg-orange-50/80 p-4 shadow-sm"
        onClick={() =>
          userInfo?.internalYn !== '1' && navigate('/M_PendingApprovals')
        }
      >
        <div className="mb-1 flex items-start justify-between">
          <p className="text-sm font-bold text-slate-800">나의 결재 대기</p>
          {waitingPaymentInfoWaitCnt > 0 && (
            <Badge
              type="NEW"
              label="NEW"
              className="text-md h-4 rounded-sm px-1.5"
            />
          )}
        </div>
        <div className="mt-1 flex items-baseline gap-0.5">
          <span className="text-2xl leading-none font-bold text-orange-600">
            {waitingPaymentInfoWaitCnt}
          </span>
          <span className="text-xs font-medium text-slate-600">건</span>
        </div>
        <p className="text-2xs mt-1 truncate text-slate-500">
          {waitingPaymentInfoLastTitle}
        </p>
      </div>
    </section>
  );
}
